import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initHero } from './modules/hero.js';
import { initHeader } from './modules/header.js';
import { initScrollToTop } from './modules/scrollToTop.js';
import { initTextAnimations } from './modules/textAnimations.js';
import { initFooterEffect } from './modules/footer.js';
import { initServicesSection, initServicesHero, initServicesTextReveal } from './modules/services.js';
import { initPortfolioSection } from './modules/portfolio.js';
import { initProjectsPage } from './modules/projects.js';
import { initAboutPage } from './modules/about.js';
import { initContactPage } from './modules/contact.js';
import { initCtaSection } from './modules/cta.js';

// Initialize Lenis
const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    smoothWheel: true,
});

// Expose Lenis globally for other modules
window.lenis = lenis;

function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// Sync Lenis with GSAP ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

// Listen for scrollToTop event (from scroll-to-top button)
window.addEventListener('scrollToTop', () => {
    lenis.scrollTo(0, { duration: 1.2 });
});

// Initialize all modules
document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initHero();
    initScrollToTop();
    initTextAnimations();
    initFooterEffect();

    // Initialize services hero FIRST (has pinSpacing)
    initServicesHero();
    initServicesTextReveal(); // Also has pinSpacing
    initAboutPage();

    // Force refresh after pinned sections are set up
    // This ensures subsequent ScrollTriggers calculate correct positions
    ScrollTrigger.refresh();

    // Now initialize sections that depend on correct scroll positions
    initServicesSection();
    initPortfolioSection();
    initProjectsPage();
    initContactPage();
    initCtaSection();

    // Hide page loader (unless waiting for project auto-open)
    const loader = document.getElementById('pageLoader');
    const isLoadingProject = document.body.classList.contains('is-loading-project');

    if (loader && !isLoadingProject) {
        // Small delay to ensure content is rendered
        setTimeout(() => {
            loader.classList.add('is-hidden');
        }, 100);
    }
});
